import { render, staticRenderFns } from "./scope45.vue?vue&type=template&id=5961bdad&scoped=true"
import script from "./scope45.vue?vue&type=script&lang=js"
export * from "./scope45.vue?vue&type=script&lang=js"
import style0 from "./scope45.vue?vue&type=style&index=0&id=5961bdad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961bdad",
  null
  
)

export default component.exports